import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border-b border-gray-200" }
const _hoisted_2 = { class: "flex place-content-between items-center px-6 py-4" }
const _hoisted_3 = { class: "mk-label text-gray-900" }
const _hoisted_4 = { class: "p-6 space-y-6 relative" }

import { MedKitIcon, MedKitRadioGroup } from '@bigpicturemedical/medkit';
import UnitOfTimeInput from '@/lib/components/Input/UnitOfTimeInput.vue';
import { BaseCard } from '@/lib/components/Card';
import { useI18n } from 'vue-i18n';
import { CLINICIAN_TYPE, CONSULT_TYPE } from '@/constants/selectOptions';
import { IPlanItem } from '@/models';
import { IErrors } from '@/lib';


export default /*#__PURE__*/_defineComponent({
  __name: 'ManagementPlanItem',
  props: {
    planItem: {},
    errors: {}
  },
  emits: ["update:consult-type", "update:clinician-type", "change:consult-in", "delete"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();



const emit = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseCard), { padding: "0" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(t)('custom.uhb.review.plan-item')), 1),
          _createElementVNode("button", {
            class: "border rounded p-3",
            "data-dusk": "delete-plan-item-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('delete')))
          }, [
            _createVNode(_unref(MedKitIcon), { icon: "delete" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(MedKitRadioGroup), {
          name: "consult-type",
          label: _unref(t)('custom.uhb.review.consult-type.name'),
          "model-value": (_ctx.planItem as Partial<IPlanItem>)?.consult_type,
          options: _unref(CONSULT_TYPE),
          error: _ctx.errors?.consult_type,
          required: "",
          "data-dusk": "consult-type",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:consult-type', $event)))
        }, null, 8, ["label", "model-value", "options", "error"]),
        _createVNode(_unref(MedKitRadioGroup), {
          name: "clinician-type",
          label: _unref(t)('custom.uhb.review.clinician-type.name'),
          "model-value": (_ctx.planItem as Partial<IPlanItem>)?.clinician_type,
          options: _unref(CLINICIAN_TYPE),
          error: _ctx.errors?.clinician_type,
          required: "",
          "data-dusk": "clinician-type",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emit('update:clinician-type', $event)))
        }, null, 8, ["label", "model-value", "options", "error"]),
        _createVNode(UnitOfTimeInput, {
          label: _unref(t)('custom.uhb.review.date-of-consult-in'),
          "unit-placeholder": _unref(t)('custom.uhb.review.unit-of-time'),
          digit: (_ctx.planItem as Partial<IPlanItem>)?.consult_in_digit,
          unit: (_ctx.planItem as Partial<IPlanItem>)?.consult_in_unit,
          error: _ctx.errors?.date_of_consult_in?.[0],
          required: "",
          "data-dusk": "unit-of-time-input",
          onChange: _cache[3] || (_cache[3] = ($event: any) => (emit('change:consult-in', $event)))
        }, null, 8, ["label", "unit-placeholder", "digit", "unit", "error"])
      ])
    ]),
    _: 1
  }))
}
}

})